import React, { ReactElement } from "react";
import { Trans } from "react-i18next";
import "./Summary.css";
import { SummaryProps } from "../../types/SummaryProps";
import { VesselGallery } from "../VesselGallery/VesselGallery";

export const Summary = (props: SummaryProps): ReactElement => {
    const getLocaleValue = (i18nKey: string) => {
        return <Trans ns="common" i18nKey={i18nKey} />;
    };

    const getSummaryText = () => {
        const summaryParagraph = props.paragraph?.trim();

        const summaryText =
            summaryParagraph ||
            getLocaleValue("inspectionReport.summary.noSummary");

        return <p className="summary">{summaryText}</p>;
    };

    const summary = <div>{getSummaryText()}</div>;

    if (props.photoData?.length) {
        return (
            <div className="grid">
                <div className="col-12 md:col-6 gallery-container">
                    <VesselGallery
                        photoData={props.photoData}
                        documentData={props.documentData}
                        section={props?.section}
                        restrictedView={props.restrictedView}
                        earlyRelease={props.earlyRelease}
                        downloadCallback={props.downloadCallback}
                    />
                </div>
                <div className="col">{summary}</div>
            </div>
        );
    }

    if (props.screeningPhoto) {
        return (
            <div className="grid">
                <div className="col-12 md:col-6 gallery-container">
                    <img src={props.screeningPhoto} className="vessel-photo" />
                </div>
                <div className="col">{summary}</div>
            </div>
        );
    }

    return (
        <div className="grid">
            <div className="col">{summary}</div>
        </div>
    );
};
